var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',{staticClass:"mt-3",attrs:{"content-class":"mt-3"}},_vm._l((_vm.links),function(link,i){return _c('b-tab',{key:i,attrs:{"title":_vm.$t(("RouterInfo." + link + ".name")),"active":link == _vm.active ? true : false},on:{"click":function($event){_vm.active = link;
      _vm.$router.push({ name: link });}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }